import { ModuleOrders } from '@modules/remotes/orders';

export function AdmModuleOrders() {
  return <ModuleOrders />;
}
